@if (body) {
<content-viewer [content]="body" (docRendered)="handleDocRendered($event)"> </content-viewer>
} @if (isDocIndex) {
<div class="-right-pane">
  @if (docIndexReady) {
  <doc-index [indexContainer]="'content-viewer'" [title]="'Within this Page'"></doc-index>
  }
</div>
}
